<template>
  <div class="col-12 voucher-preview">
    <div class="d-flex">
      <div class="media">
        <div class="media-body">
          <div class="h2">แบบตัวอย่าง</div>
          <div class="preview-sub-header">เค้าโครงมือถือ</div>
        </div>
      </div>
    </div>
    <div>
      <div class="mobile-box text-center">
        <mobile-box
          :title="value.title"
          :image-url="imageUrl"
          :content-html="contentHtml"
        ></mobile-box>
      </div>
    </div>
  </div>
</template>

<script>
import MobileBox from "./MobileBox";

export default {
  components: {
    MobileBox
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    imageUrl: {
      type: String,
      default: null,
    },
    contentHtml: {
      type: String,
      default: null,
    },
  }
}
</script>

<style scoped>
.voucher-preview {
  padding-top: 16px;
}
.preview-sub-header {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
}
</style>